import React from "react";
import { IdView, Typography } from "../../../../components";
import { OnlyFansAccount } from "../../../../api/staff";

interface IdCellProps {
  account: OnlyFansAccount;
}

/**
 * IdCell Component
 *
 * Renders the account ID in short format with copy functionality
 */
const IdCell: React.FC<IdCellProps> = ({ account }) => {
  const formatShortId = (id: string) => {
    if (!id) return '';
    if (id.length <= 8) return id;
    return `${id.slice(0, 4)}...${id.slice(-4)}`;
  };

  return (
    <div className="flex items-center gap-[8px]">

      <IdView
      //@ts-ignore
        textToCopy={account._id}
      >
        {/* @ts-ignore */}
        {account._id.slice(-4)}
      </IdView>
    </div>
  );
};

export default IdCell;
